import(/* webpackMode: "eager" */ "/app/next/src/app/[locale]/projects/[project]/error.tsx");
